import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import SaleRegister from '../pages/Sale/register/SaleRegister';
import SaleHistory from '../pages/Sale/history/SaleHistory';
import CustomerPage from '../pages/Customer/CustomerPage';
import SaleCancel from '../pages/Sale/cancel/SaleCancel';
import ProtectedRouteV2 from './ProtectedRouteV2';
import QuotationRegisterPage from '../pages/Sale/quotation/QuotationRegisterPage';
import QuotationHistoryPage from '../pages/Sale/quotation/QuotationHistoryPage';
import ReturnEventsPage from '../pages/Sale/fiscal/ReturnEventsPage';
// Operaciones Especiales: módulo no activo todavía, ruta deshabilitada a propósito.
// import SpecialOperationsPage from '../pages/Hacienda/SpecialOperationsPage';
import FiscalEventsPage from '../pages/Sale/fiscal/FiscalEventsPage';
import SalesTipSettingsPage from '../pages/Sale/settings/SalesTipSettingsPage';

const salesRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/sale-register"
      element={
        <>
          <PageTitle title="Registrar Venta | POS System" />
          <SaleRegister />
        </>
      }
    />
    <Route
      path="/sale-history"
      element={
        <>
          <PageTitle title="Historial de Ventas | POS System" />
          <SaleHistory />
        </>
      }
    />
    <Route
      path="/sale-cancel"
      element={
        <>
          <PageTitle title="Anular Venta | POS System" />
          <SaleCancel />
        </>
      }
    />
    <Route
      path="/customers"
      element={
        <>
          <PageTitle title="Clientes | POS System" />
          <CustomerPage />
        </>
      }
    />
    
    <Route
      path="/quotation-register"
      element={
        <>
          <PageTitle title="Registrar Cotización | POS System" />
          <QuotationRegisterPage />
        </>
      }
    />

    <Route
      path="/quotation-history"
      element={
        <>
          <PageTitle title="Historial de Cotizaciones | POS System" />
          <QuotationHistoryPage />
        </>
      }
    />
    <Route path="/sales/returns" element={<><PageTitle title="Eventos de Retorno | POS System" /><ReturnEventsPage /></>} />
    <Route path="/sales/returns/:saleId" element={<><PageTitle title="Eventos de Retorno | POS System" /><ReturnEventsPage /></>} />
    {/* Operaciones Especiales: módulo no activo todavía, ruta deshabilitada a propósito.
    <Route path="/sales/special-operations" element={<><PageTitle title="Operaciones Especiales | POS System" /><SpecialOperationsPage /></>} /> */}
    <Route path="/sales/fiscal-events" element={<><PageTitle title="Historial de Eventos | POS System" /><FiscalEventsPage /></>} />
    <Route path="/sales/settings/tip" element={<><PageTitle title="Propina | POS System" /><SalesTipSettingsPage /></>} />
  </Route>
);

export default salesRoutes;
